import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "text-12px xxl:text-14px text-gray-lp-300" }
const _hoisted_3 = { class: "text-20px text-red-lp-300 font-semibold" }
const _hoisted_4 = {
  key: 2,
  class: "ml-4"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "border-b border-gray-lp-400" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-16px p-4" }, "Jenis Pembayaran")
], -1)
const _hoisted_6 = { class: "px-4 cursor-pointer" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "text-14px font-medium text-gray-lp-300 col-span-3" }, " Pembayaran Tunai ", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_9 = { class: "text-14px font-medium text-gray-lp-300 col-span-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cash = _resolveComponent("Cash")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('bookingShipment.payment.title')), 1),
    (_ctx.paymentMethodActive.name)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "flex items-center cursor-pointer select-none",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.togglePaymentMethods && _ctx.togglePaymentMethods(...args)))
        }, [
          (_ctx.paymentMethodActive.name === 'cash')
            ? (_openBlock(), _createBlock(_component_Cash, {
                key: 0,
                class: "text-red-lp-300 mr-3"
              }))
            : (_openBlock(), _createBlock("img", {
                key: 1,
                alt: "payment-logo",
                class: "self-center w-12 mr-3",
                src: 
          require(`@/app/ui/assets/svg/payment/${_ctx.paymentMethodActive.logo}-active.svg`)
        
              }, null, 8, ["src"])),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.accountIsNonForeign ? _ctx.paymentMethodActive.title : _ctx.$t('bookingShipment.payment.cash')), 1),
          (_ctx.accountIsNonForeign)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("img", {
                  alt: "",
                  class: "cursor-pointer select-none",
                  src: 
            require(`@/app/ui/assets/svg/${
              _ctx.showPaymentMethods ? 'chevron-up-light' : 'chevron-down-light'
            }.svg`)
          
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: "absolute border-l w-72 border-r flex flex-col bg-white rounded-bl rounded-br shadow",
      style: `margin-top: ${_ctx.isDiscount ? '50px' : '25px'};`
    }, [
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.payWithCash && _ctx.payWithCash(...args))),
          class: "grid grid-cols-4 py-4"
        }, [
          _createVNode(_component_Cash, { class: "text-black" }),
          _hoisted_7
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (payment, index) => {
          return (_openBlock(), _createBlock(_Fragment, { key: index }, [
            _hoisted_8,
            _createVNode("div", {
              onClick: ($event: any) => (_ctx.payWithQr(payment)),
              class: "grid grid-cols-4 py-4"
            }, [
              _createVNode("img", {
                alt: "payment-logo",
                class: "self-center w-8",
                src: 
                require(`@/app/ui/assets/svg/payment/${payment.logo}-active.svg`)
              
              }, null, 8, ["src"]),
              _createVNode("div", _hoisted_9, " Pembayaran " + _toDisplayString(payment.title), 1)
            ], 8, ["onClick"])
          ], 64))
        }), 128))
      ])
    ], 4), [
      [_vShow, _ctx.showPaymentMethods]
    ])
  ], 512)), [
    [_directive_click_outside, _ctx.forceClosePaymentMethods]
  ])
}